export default function removeAllNonNumberCharacters(string: string): string {
  return string.replace(/[^\d]+/g, '');
}
